import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LOADING_STATES } from '../constants/loading-state.constant';
import { getActiveRolesAct } from '../managers/AuthManager/actions';
import {
  selectActiveRoles,
  selectRolesLoadingState,
} from '../managers/AuthManager/selectors';

export function useRoles() {
  const dispatch = useDispatch();

  // Selectors
  const roles = useSelector(selectActiveRoles);
  const loadingState = useSelector(selectRolesLoadingState);

  // Actions
  const loadRoles = useCallback(() => {
    dispatch(getActiveRolesAct(LOADING_STATES.LOADING));
  }, [dispatch]);

  return {
    // Essential data only
    roles,
    loadingState,
    // Essential actions only
    loadRoles,
  };
}
